import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/life',
      beforeEnter(to, from, next) {
        // Put the full page url including the protocol http(s) below
        window.location = "https://docs.google.com/presentation/d/1GT2iNiKT-CZBt7_DXmVs4eJgV91JN5vt1H6WT5yvNR8/edit?usp=sharing"
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js